"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppMockStates = void 0;
var onboarding_1 = require("./onboarding");
var pay_now_1 = require("./pay-now");
var rent_tracker_1 = require("./rent-tracker");
var service_issue_1 = require("./service-issue");
var settings_1 = require("./settings");
var credit_builder_1 = require("./credit-builder");
var embed_1 = require("./embed");
exports.AppMockStates = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, onboarding_1.OnboardingMockStates), pay_now_1.PayNowMockStates), rent_tracker_1.RentTrackerMockStates), service_issue_1.ServiceIssueMockStates), settings_1.SettingsMockStates), credit_builder_1.CreditBuilderMockStates), embed_1.EmbedStates);
